import { render } from "./DesignerProcess.vue?vue&type=template&id=a233f206&scoped=true"
import script from "./DesignerProcess.vue?vue&type=script&lang=js"
export * from "./DesignerProcess.vue?vue&type=script&lang=js"

import "./DesignerProcess.vue?vue&type=style&index=0&id=a233f206&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a233f206"]])

export default __exports__